module.exports = __webpack_public_path__ + "static/img/layout.b5ee0a58.svg";